import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  ModalBody,
  Label,
} from "reactstrap";
import Utils from "../../Utility";
import { post, get, put, upload } from "../../../helpers/api_helper";
import DeleteModal from "./DeleteModal";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import UserProfile from "../../../components/UserProfile";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";
import moment from "moment/moment";
import { useHistory } from "react-router-dom";
import imgpdf from "../../../assets/images/imgpdf.jpg";
import Loader from "../../../components/Loader";
const Table = (props) => {
  const { user } = props;
  const history = useHistory();
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [isAddForm, setIsAddForm] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [userModal, setUserModal] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(undefined);
  const [selectedLang, setSelectedLang] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [file, setFile] = useState(null);
  const [audio, setAudio] = useState(null);
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(true);
  const imageInput = useRef();
  const cropper = useRef();

  useEffect(() => {
    if (user) {
      getData();
    }
  }, [user]);

  const getData = () => {
    setLoading(true); // Set loading state to true when making the API request
    get("/job", { token: user?.token })
      .then((json) => {
        setLoading(false);
        console.log("response from get project list", json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch((error) => {
        console.log("error while getting project list", error);
        setLoading(false); // Set loading state to true when making the API request
      });
  };

  useEffect(() => {
    setColumns([
      // {
      //   name: "Job Id",
      //   selector: (row) => <span>IDPL0001</span>,
      //   maxWidth: "auto",
      //   // sortable: true,
      // },
      {
        name: "Plant",
        cell: (row) => (
          <>
            <span plant={row?.plant}>{row?.plant}</span>
          </>
        ),
        maxWidth: "560px",
        // sortable: true,
      },
      {
        name: "Title",
        selector: (row) => row?.title,
        maxWidth: "570px",
        // sortable: true,
      },
      {
        name: "Valid till",
        selector: (row) => moment(row?.valid_till).format("DD-MMM-YYYY"),
        maxWidth: "auto",
        // sortable: true,
      },
      {
        name: " View Pdf",
        cell: (row) => (
          <>
            <div>
              <a href={row?.pdf} className="view_pdf" target="blank">
                <img src={imgpdf} alt="" style={{ width: 30, height: 30 }} />
              </a>
            </div>
          </>
        ),
        selector: (row) => row._id,
        maxWidth: "100px",
        // sortable: true,
      },
      {
        cell: (row) => (
          <div className="table_btn">
            <button
              onClick={() => handleUpdateStatus(row)}
              className={row?.isActive ? "active_status" : "inactive_status"}
            >
              <span className="text-white" style={{}}>
                {row?.isActive ? "Active" : "Inactive"}
              </span>
            </button>
          </div>
        ),
        name: "Status",
        ignoreRowClick: true,
        maxWidth: "100px",
        sortable: true,
      },
      {
        cell: (row) => (
          <>
            <div className="action_btn table_btn">
              {/* <button onClick={() => history.push("/job-master")}>
                <i class="mdi mdi-plus"></i>
              </button> */}
              <button
                onClick={() =>
                  history.push("/job-master", {
                    row,
                  })
                }
                t
              >
                <i class="mdi mdi-pencil"></i>
              </button>
            </div>
          </>
        ),
        name: "Action",
        ignoreRowClick: true,
        maxWidth: "120px",
      },
    ]);
  }, []);

  useEffect(() => {
    if (!isAddForm) {
      setCurrentData(null);
      setFile(null);
      setAudio(null);
      setCurrentAudio(null);
      setSelectedLang([]);
    }
  }, [isAddForm]);

  const handlePaid = (row) => {
    setCurrentData({ ...row, actionType: "Paid" });
    setDeleteModal(true);
  };

  const handleUpdateProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData(proj);
    setFile(proj?.image);
    setAudio(proj?.audio);
    if (proj?.alterLang?.length) {
      proj?.alterLang?.forEach((lang) => {
        user?.languages?.forEach((allLang) => {
          if (allLang?.code == lang?.code) lang.lang = allLang?.title;
        });
      });
      setSelectedLang(proj?.alterLang);
    }
    setIsAddForm(true);
  };

  const handleUpdateStatus = (item, type) => {
    setCurrentData({ ...item, actionType: "Status" });
    setDeleteModal(true);
  };

  const handleUpdateLive = (row) => {
    setCurrentData({ ...row, actionType: "Live" });
    setDeleteModal(true);
  };

  const handleDeleteProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData({ ...proj, actionType: "Delete" });
    setDeleteModal(true);
  };

  const onDelete = () => {
    let body = {
      jobId: currentData?._id,
      isActive: currentData?.isActive ? false : true,
    };
    put("/job", body)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode == 200) {
          toast.success(res?.message);
          setDeleteModal(false);
          getData();
          props?.setCurrentData(null);
        } else {
          toast.error(res?.error);
        }
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  };

  const handleDragEnd = (result) => {
    console.log("dragging item", result);
    // Handle the drag-and-drop logic here
    if (!result.destination) return; // Item was dropped outside the list
    const items = [...data];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let ids = [],
      position = [];
    items.forEach((item, index) => {
      ids.push(item?._id);
      position.push(index);
    });
    let body = {
      ids,
      position,
      token: user?.token,
    };
    put("/podcast/position", body).then((res) => {
      // if (res?.statusCode == 200)
      setData(items);
    });
  };

  const onChangeFile = async (e) => {
    // console.log('on change file', e.target);
    setFile(URL.createObjectURL(e.target.files[0]));
    // setCropperModal(true);
  };

  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1800,
        600,
        "webp",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });

  const handleValidSubmit = async (e, v) => {
    console.log("values", v);
    let body = {
      ...v,
      alterLang: selectedLang,
      token: user?.token,
    };
    setLoading(true);
    if (file.substring(0, 4) == "blob") {
      const fileData = cropper?.current?.cropper
        ?.getCroppedCanvas()
        .toDataURL();
      const obj = await urltoFile(
        fileData,
        new Date().getTime() + ".webp",
        "image/webp"
      );
      const temp = await resizeFile(obj);
      const form = new FormData();
      form.append("image", temp);
      const imageRes = await upload("/podcast/image_upload", form);
      body = { ...body, image: imageRes?.data };
    }
    if (audio.substring(0, 4) == "blob") {
      const obj = await urltoFile(
        audio,
        new Date().getTime() + ".mp3",
        "audio/mpeg"
      );
      // const temp = await resizeFile(obj);
      const form = new FormData();
      form.append("image", obj);
      const imageRes = await upload("/podcast/image_upload", form);
      body = { ...body, audio: imageRes?.data };
    }
    if (currentData) {
      body = { ...body, jobId: currentData?._id };
      put("/job", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    } else {
      post("/tender", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }
  };

  const handleToggleAudio = (row, index) => {
    setCurrentAudio(row?.audio);
    console.log("playing", row, index);
    const audioElement = document.getElementById("audio");
    if (!audioElement) return;
    if (row?.isPlaying) {
      audioElement.pause();
      if (currentData) {
        setCurrentData({ ...currentData, isPlaying: false });
      } else {
        let dat = Object.assign([], data);
        dat[index].isPlaying = false;
        setData(dat);
      }
    } else {
      audioElement.pause();
      setTimeout(() => {
        audioElement.play();
        if (currentData) {
          setCurrentData({ ...currentData, isPlaying: true });
        } else {
          let dat = Object.assign([], data);
          dat.map((item, inde) => {
            if (inde == index) item.isPlaying = true;
            else item.isPlaying = false;
          });
          setData(dat);
        }
      }, 500);
    }
  };

  const handleSelectLang = (code, lang) => {
    let temp = Object.assign([], selectedLang);
    let already = temp.findIndex((x) => x.code == code);
    if (already == -1) {
      temp.push({ code: code, title: "", lang });
    } else {
      temp.splice(already, 1);
    }
    // console.log("temp", temp);
    setSelectedLang(temp);
  };

  const handleAlterTitle = (index, key, val) => {
    let temp = Object.assign([], selectedLang);
    temp[index][key] = val;
    setSelectedLang(temp);
  };

  const parseDate = (str) => {
    if (str) {
      let date = str?.split(":");
      let modify = date[0] + ":" + date[1];
      // console.log("date", str, date[0] + ":" + date[1]);
      return modify;
    } else return "";
  };

  const handleExpandRow = (row) => {
    if (expandedRows.includes(row.id)) {
      setExpandedRows(expandedRows.filter((id) => id !== row.id));
    } else {
      setExpandedRows([...expandedRows, row.id]);
    }
  };

  const isRowExpanded = (row) => expandedRows.includes(row.id);
  const ExpandedComponent = ({ data }) => (
    <div style={{ margin: "20px", padding: "20px", border: "2px solid green" }}>
      {/* Render additional content for expanded row */}
      <p>
        {/* Render all details of the expanded row */}

        {/* <p>
          {" "}
          <strong>Job Id:</strong> {data.Id}
        </p> */}
        <p>
          {" "}
          <strong>Plant : </strong> {data.plant}
        </p>
        <hr />
        <p>
          {" "}
          <strong>Title : </strong> {data.title}
        </p>
        <hr />
        <p>
          {" "}
          <strong>Valid till : </strong>
          {moment(data?.valid_till).format("DD-MMM-YYYY")}
        </p>
        <hr />
        <p>
          {" "}
          <strong>View Pdf : </strong>
          <a href={data.pdf} className="view_pdf" target="blank">
            <img src={imgpdf} alt="pdf" style={{ width: 30, height: 30 }} />
          </a>
        </p>
        <hr />
        <p>
          {" "}
          <strong>Created Date : </strong>{" "}
          {moment(data?.createdAt).format("DD-MMM-YYYY")}
        </p>
        <hr />
        {/* <p>
          {" "}
          <strong>News Panel Status:</strong> {data.news_panel}
        </p>
        <hr /> */}
        <p>
          {" "}
          <strong>News Panel Status : </strong>{" "}
          {data.news_panel ? (
            <span>
              <input type="checkbox" checked readOnly /> Checked
            </span>
          ) : (
            "Not Checked"
          )}
        </p>
        <hr />
        {/* Add more details here as needed */}
      </p>
    </div>
  );

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <UserProfile
            userId={currentUserId}
            show={userModal}
            onCloseClick={() => setUserModal(false)}
            user={user}
          />
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            data={currentData}
          />
          <Modal isOpen={isAddForm} centered={true} style={{ maxWidth: 800 }}>
            <ModalBody className="py-3 px-5">
              <h5 className="text-black font-size-20">
                {currentData ? `View Job` : `View Job List`}
              </h5>
              <div className="p-2">
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v, "bank");
                  }}
                >
                  <Row>
                    <Col lg={12} md={12}>
                      <div className="mb-3">
                        {file ? (
                          <>
                            <CardTitle>Image</CardTitle>
                            <div
                              style={{
                                flexDirection: "row",
                                position: "relative",
                                cursor: "pointer",
                                marginTop: 20,
                              }}
                            >
                              {currentData?.image ? (
                                <img
                                  src={file}
                                  style={{ width: 584, height: "auto" }}
                                />
                              ) : (
                                <Cropper
                                  style={{ height: "auto", width: 584 }}
                                  aspectRatio={1 / 1}
                                  preview=".img-preview"
                                  guides={true}
                                  src={file}
                                  ref={cropper}
                                />
                              )}
                              <i
                                className="mdi mdi-close"
                                style={{
                                  color: "white",
                                  backgroundColor: Utils.themeColor,
                                  fontSize: 20,
                                  position: "absolute",
                                  top: -16,
                                  right: -12,
                                  borderRadius: 15,
                                  width: 30,
                                  height: 30,
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  setFile(null);
                                  if (currentData)
                                    setCurrentData({
                                      ...currentData,
                                      image: undefined,
                                    });
                                }}
                              />
                            </div>
                          </>
                        ) : (
                          <AvField
                            name="fileInput"
                            label="Image"
                            className="form-control"
                            placeholder="upload bank logo"
                            type="file"
                            onChange={(e) => onChangeFile(e)}
                            required
                            multiple={false}
                            ref={imageInput}
                            accept="image/png, image/jpeg"
                            // value={currentData?.logo}
                          />
                        )}
                      </div>
                    </Col>
                    <Col lg={12} md={12}>
                      {audio ? (
                        <div className="mb-3">
                          <Label>Audio</Label>
                          <div className="d-flex align-items-center">
                            <span
                              style={{
                                border: "1px solid " + Utils.themeColor,
                                borderRadius: 70,
                                width: 30,
                                height: 30,
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                cursor: "pointer",
                              }}
                              onClick={() => handleToggleAudio(currentData, 0)}
                            >
                              {currentData?.isPlaying ? (
                                <i
                                  className="mdi mdi-pause"
                                  style={{
                                    fontSize: 20,
                                    color: Utils.themeColor,
                                    marginTop: 3,
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="mdi mdi-play"
                                  style={{
                                    fontSize: 20,
                                    color: Utils.themeColor,
                                    marginTop: 3,
                                  }}
                                ></i>
                              )}
                            </span>
                            <span
                              style={{
                                border: "1px solid " + Utils.themeColor,
                                borderRadius: 70,
                                marginLeft: 5,
                                width: 30,
                                height: 30,
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                document.getElementById("audio").pause();
                                setAudio(null);
                                setCurrentData({
                                  ...currentData,
                                  isPlaying: false,
                                  audio: undefined,
                                });
                              }}
                            >
                              <i
                                className="mdi mdi-close"
                                style={{
                                  fontSize: 20,
                                  color: Utils.themeColor,
                                  marginTop: 5,
                                }}
                              ></i>
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="mb-3">
                          <AvField
                            name="file_audio"
                            label="Audio *"
                            className="form-control"
                            type="file"
                            accept="audio/mpeg"
                            onChange={(e) => {
                              setCurrentAudio(
                                URL.createObjectURL(e.target.files[0])
                              );
                              setAudio(URL.createObjectURL(e.target.files[0]));
                            }}
                            required={data ? false : true}
                          />
                        </div>
                      )}
                    </Col>
                    <Col lg={12} md={12}>
                      <div className="mb-3">
                        <AvField
                          name="scheduleAt"
                          label="Schedule At *"
                          className="form-control"
                          placeholder="Enter live session url"
                          type="datetime-local"
                          required
                          value={parseDate(currentData?.scheduleAt)}
                        />
                      </div>
                    </Col>
                    <Col lg={12} md={12}>
                      <div className="mb-3">
                        <AvField
                          name="title"
                          label="Title *"
                          className="form-control"
                          placeholder="Enter sound title"
                          type="text"
                          required
                          value={currentData?.title}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Label>Alternative Languages</Label>
                  <Row>
                    <div className="lang-checks mb-3">
                      {user?.languages?.map((item) => (
                        <div className="check-group">
                          <label for={item?.title} class="container">
                            {item?.title}
                            <input
                              type="checkbox"
                              name={item?.title}
                              id={item?.title}
                              checked={
                                selectedLang.findIndex(
                                  (x) => x?.code == item?.code
                                ) != -1
                              }
                              onChange={(e) =>
                                handleSelectLang(item?.code, item?.title)
                              }
                            />
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      ))}
                    </div>
                    {selectedLang?.map((item, index) => (
                      <Row>
                        <Col md={12}>
                          <div className="mb-3">
                            <AvField
                              name={"title" + item?.lang}
                              label={"Title in " + item?.lang}
                              className="form-control"
                              placeholder={"Enter title in " + item?.lang}
                              type="text"
                              onChange={(e) =>
                                handleAlterTitle(index, "title", e.target.value)
                              }
                              required
                              value={item?.title}
                            />
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </Row>
                  <div className="mt-4">
                    <Row>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                          onClick={() => {
                            setIsAddForm(false);
                          }}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                        >
                          {currentData ? "Update" : "Add"}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </AvForm>
              </div>
            </ModalBody>
          </Modal>

          <Col className="col-12">
            <div className="table_top_header">
              <CardTitle className="h4">
                <i class="mdi mdi-eye"></i> View jobs{" "}
              </CardTitle>
              {/* <ul>
                <li>
                  <button>
                    <i class="mdi mdi-download"></i>
                  </button>
                  <button>
                    <i class="mdi mdi-settings"></i>
                  </button>
                </li>
              </ul> */}
            </div>
            <Card style={{ borderRadius: "0" }} className="table-body-section">
              <CardBody>
                <div className="table-search-section">
                  {/* <div className="search_field">
                    <label>Search :</label>
                    <input
                      type="text"
                      value={""}
                      onChange={(e) => handleFilter(e.target.value)}
                    />
                  </div> */}
                </div>
                <Loader visible={loading} />
                {loading && <div>Loading...</div>}
                <DataTable
                  columns={columns}
                  data={data}
                  pagination
                  // selectableRows
                  expandableRows
                  expandableRowsComponent={ExpandedComponent}
                  onRowClicked={(row) => handleExpandRow(row)}
                  expandOnRowClicked
                  isRowExpandable={(row) => true}
                  isRowExpanded={isRowExpanded}
                  paginationPerPage={100}
                  paginationRowsPerPageOptions={[100, 200, 300, 400]}
                  conditionalRowStyles={[
                    {
                      when: (row) => row?.style,
                      style: (row) => ({ width: row?.style?.width }),
                    },
                  ]}
                  customStyles={{
                    headCells: {
                      style: {
                        color: "black",
                        fontWeight: "bold",
                        fontSize: 15,
                        width: 0,
                      },
                    },
                    cells: {
                      style: {
                        width: 0,
                      },
                    },
                  }}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Table;
